import React from "react"
import { useStaticFeature } from "hooks/use-feature"
import { VerticalNavSidebar } from "./vertical-nav-sidebar"
import { ReactRbPageHeader } from "./react-rb-page-header"

/**
 * ReactRbLayout provides the page layout for react-rb pages.
 *
 * Switches between horizontal nav (column layout) and vertical nav (row layout)
 * based on the vertical_nav feature flag, mirroring InertiaVerticalNavLayout
 * for Inertia pages.
 */
export function ReactRbLayout({ children }) {
  const { enabled: verticalNavEnabled } = useStaticFeature("vertical_nav")

  if (!verticalNavEnabled) {
    return (
      <>
        <ReactRbPageHeader />
        <main style={{ display: "flex", flex: "1 1 auto", flexDirection: "column" }}>
          {children}
        </main>
      </>
    )
  }

  return (
    <div style={{ display: "flex", flex: "1 1 auto" }}>
      <VerticalNavSidebar />
      <main className="flex-1 min-w-0 bg-white rounded-xl mr-3 my-3 p-6 overflow-y-auto max-h-[calc(100vh-24px)]">
        <ReactRbPageHeader bannersOnly />
        {children}
      </main>
    </div>
  )
}
